import React from 'react';
import styled from 'styled-components';
import { CheckCircleOutline } from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  text-align: center;
`;

const StatusBox = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
`;

const StatusIndicator = styled.div`
  background-color: #28a745; /* Green for operational */
  color: white;
  padding: 15px;
  border-radius: 5px;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Status = () => {
  return (
    <PageContainer>
      <h1>Service Status</h1>
      <p>Check the current operational status of DevOps Buddy services.</p>
      <StatusBox>
        <StatusIndicator>
          <CheckCircleOutline style={{ marginRight: '10px' }} />
          All Systems Operational
        </StatusIndicator>
        <p>All services are currently running smoothly. There are no reported issues at this time.</p>
        <small>Last checked: {new Date().toLocaleString()}</small>
      </StatusBox>
    </PageContainer>
  );
};

export default Status;
